// extracted by mini-css-extract-plugin
module.exports = {"dragable":"style_dragable__36A3L","over":"style_over__s05_X","uploadResult":"style_uploadResult__3benc"};